<template>

    <section
            class="tags"
            v-bind:class="{ 'isEmpty' : articlePrimaryKeywordData.length === 0 && articleSeriesKeywordData.length === 0 && articleSequencingKeywordData.length === 0 }"
    >

        <template v-for="(primaryKeyword, primaryKeywordIndex) in articlePrimaryKeywordData">
            <a :href="'/thema/' + encodeURIComponent(primaryKeyword.name)" class="tag">
                <button
                        class="btn btn-pink-white-black-white"
                        v-html="primaryKeyword.name"
                ></button>
            </a>
        </template>
        <template v-for="(seriesKeyword, seriesKeywordIndex) in articleSeriesKeywordData">
            <a :href="'/thema/' + encodeURIComponent(seriesKeyword.name)" class="tag">
                <button
                        class="btn btn-pink-white-black-white"
                        v-html="seriesKeyword.name"
                ></button>
            </a>
        </template>
        <template v-for="(sequencingKeyword, sequencingKeywordIndex) in articleSequencingKeywordData">
            <a :href="'/thema/' + encodeURIComponent(sequencingKeyword.name)" class="tag">
                <button
                        class="btn btn-pink-white-black-white"
                        v-html="sequencingKeyword.name"
                ></button>
            </a>
        </template>

    </section>

</template>

<script>

    // console.log('Tags');

    export default {
        created(){
        },
        destroyed(){
        },
        mounted(){
        },
        components : {},
        computed : {},
        data(){
            return {};
        },
        props : {
            'articlePrimaryKeywordData' : {
                default : ()=>{
                    return [];
                },
                type : Array,
            },
            'articleSeriesKeywordData' : {
                default : ()=>{
                    return [];
                },
                type : Array,
            },
            'articleSequencingKeywordData' : {
                default : ()=>{
                    return [];
                },
                type : Array,
            },
        },
        methods : {},
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .tags {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: flex-start;
        margin: -0.25rem -0.25rem (3.5rem - 0.25rem) -0.25rem;
        @media screen and (min-width: 1200px) {
            margin: -0.25rem * $factor-1200 -0.25rem * $factor-1200 (3.5rem - 0.25rem) * $factor-1200 -0.25rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            margin: -0.25rem * $factor-1440 -0.25rem * $factor-1440 (3.5rem - 0.25rem) * $factor-1440 -0.25rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            margin: -0.25rem * $factor-1920 -0.25rem * $factor-1920 (3.5rem - 0.25rem) * $factor-1920 -0.25rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            margin: -0.25rem * $factor-2400 -0.25rem * $factor-2400 (3.5rem - 0.25rem) * $factor-2400 -0.25rem * $factor-2400;
        }
        &:empty,
        &.isEmpty {
            margin-top: 0;
            margin-bottom: 0;
        }
        .tag {
            flex: 1 0 auto;
            padding: 0.25rem;
            @media screen and (min-width: 1200px) {
                padding: 0.25rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding: 0.25rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding: 0.25rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding: 0.25rem * $factor-2400;
            }
            .btn {
                width: 100%;
                background-color: $color-nochvielvor-black;
                color: $color-nochvielvor-white;
                text-transform: uppercase;
            }
        }
    }

</style>
